import React from 'react';
import intl from 'react-intl-universal';
import Packs from './Packs';
import PackActions from '../actions/PackActions';
import AuthStore from '../stores/AuthStore';
import { withRouter } from 'react-router-dom';

class ScanCartComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      cartkod: '',
      error: false,
      listMode: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.toggleMode = this.toggleMode.bind(this)
  }

  handleChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  toggleMode() {
    this.setState({
      listMode: !this.state.listMode
    });
  }

  componentDidUpdate() {
    if(document.querySelector('[type="submit"]')){
      document.querySelector('[type="submit"]').disabled = false
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    let kod = document.getElementById('cartkod').value
    if (kod){
      document.querySelector('[type="submit"]').disabled = true
      PackActions.getCart(kod, AuthStore.getUser().id, AuthStore.getPakowalnia())
    }
  }

  render() {
    return (
      <div>
        {this.state.listMode &&
          <div>
            <Packs/>
            <div className="buttons_wrap">
              <button onClick={this.toggleMode} className="pull-left">{intl.get('Anuluj')}</button>
            </div>
          </div>
        }
        {!this.state.listMode &&
          <form onSubmit={this.handleSubmit}>
            <div className="ramka center">
              <h4>{intl.get('Skanowanie wózka')}</h4>
                <label htmlFor="cartkod">{intl.get('Kod wózka')}: </label>
                <input
                  className="searchBox"
                  name="cartkod"
                  id="cartkod"
                  type="text"
                  value={this.state.cartkod}
                  onChange={this.handleChange} />
                { this.state.error &&
                  <div className="failed">
                    {intl.get('Nie znaleziono wózka!')}'
                  </div>
                }
            </div>
            <div className="buttons_wrap">
              <input type="submit" className="pull-right" value={intl.get('Dalej')} />
            </div>
            <div className="ramka center">
              <h4>{intl.get('Wybór paczki')}</h4>
              <button onClick={this.toggleMode}>{intl.get('Pokaż listę paczek')}</button>
            </div>
          </form>
        }
      </div>
    );
  }
}

export default withRouter(ScanCartComponent);



// WEBPACK FOOTER //
// ./src/components/ScanCart.js